import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

const BaseButton = styled.span(
  () => () =>
    mq({
      padding: `${defaultTheme.spacing.m} ${defaultTheme.spacing.l}`,
      color: defaultTheme.color.primary,
      fontSize: defaultTheme.font.size.m,
      fontWeight: 'bold',
      textAlign: 'center',
      border: `2px solid ${defaultTheme.color.primary}`,
      borderRadius: defaultTheme.border.radius.s,
    }),
);

export const RaceStopButton = styled(BaseButton)(() =>
  mq({
    color: defaultTheme.color.grayScale.dark,
    backgroundColor: defaultTheme.background.mediumGray,
    border: 'inherit',
  }),
);

export const ResultButtonLink = styled(BaseButton)(() =>
  mq({
    ...hoverOpacity,
  }),
).withComponent(Link);

export const DisabledResultButton = styled(BaseButton)(() =>
  mq({
    opacity: defaultTheme.button.opacity.disabled,
  }),
);

export const BetButtonLink = styled(BaseButton)(() =>
  mq({
    color: defaultTheme.color.white,
    backgroundColor: defaultTheme.background.primary,
    ...hoverOpacity,
  }),
).withComponent(Link);
